import React from "react";
import style from "./Fields.module.scss";
import Autosuggest from "../../../Autosuggest/Autosuggest";
import { Field } from "../../Order/Field/Field";

const Process = ({ value, error, disabled, onChange, fetchProcesses }) => {
  const fetchSearch = ({ value }) => {
    return new Promise((resolve) => {
      fetchProcesses((response) => {
        const filteredProcesses = response.SdtComboCollection.enum.filter((p) =>
          p.toLowerCase().includes(value.toLowerCase())
        );
        resolve(
          filteredProcesses.map((p, i) => ({
            id: i,
            name: p,
          }))
        );
      });
    });
  };

  const internalOnChange = (method, value) => {
    let _value = {
      processId: null,
      processes: "",
    };

    if (method !== "type" && value.id) {
      _value.processId = value.id;
      _value.processes = value.name;
    }

    onChange(_value);
  };

  return (
    <Field label={"Process"} error={error}>
      <Autosuggest
        renderSuggestion={(suggestion) => (
          <div className={style.suggestionItem}>
            <span>{suggestion.name}</span>
          </div>
        )}
        getSuggestionValue={(s) => `${s.name}`}
        onSuggestionsFetchRequested={fetchSearch}
        value={value || ""}
        inputProps={{
          placeholder: "Process",
          invalid: !!error,
          disabled,
          style: { fontWeight: 500 },
        }}
        onChange={(m, v) => internalOnChange(m, v)}
      />
    </Field>
  );
};

export default Process;
